/**
 * ScrollableContent - Contenuto scrollabile per le pagine
 * Gestisce il contenuto principale con scroll interno
 */

import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface ScrollableContentProps {
  children: ReactNode;
  maxHeight?: string;
}

const ScrollableContent: React.FC<ScrollableContentProps> = ({ 
  children, 
  maxHeight = 'calc(100vh - 300px)' 
}) => {
  return (
    <Box sx={{ 
      flex: 1, 
      overflow: 'hidden', 
      display: 'flex', 
      flexDirection: 'column' 
    }}>
      <Box sx={{ 
        maxHeight,
        overflow: 'auto',
        flex: 1
      }}>
        {children}
      </Box>
    </Box>
  );
};

export default ScrollableContent;
